/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

import StatisticsController from './statistics.controller';

export default angular.module('tektelic.statistics', [])
    .controller('StatisticsController', StatisticsController)
    .name;



// WEBPACK FOOTER //
// ./src/app/statistics/index.js